import { gql } from '@apollo/client';

export default gql`
  mutation createUnpublishData($userId: String) {
    unpublish(userId: $userId)
  }
`;
